import { fetch } from "../../../appContainer";
import {
  GET_NOMENCLATURES_IN_PROGRESS,
  GET_NOMENCLATURES_SUCCESS,
  GET_NOMENCLATURES_FAIL,
} from "../constants";

/**
 * Get installations list
 */
export function getNomenclatures() {
  return (dispatch) => {
    dispatch({ type: GET_NOMENCLATURES_IN_PROGRESS });

    fetch("api").getNomenclatures(
      (nomenclatures) => {
        dispatch({
          type: GET_NOMENCLATURES_SUCCESS,
          payload: { nomenclatures },
        });
      },
      () => dispatch({ type: GET_NOMENCLATURES_FAIL })
    );
  };
}
